import { Stack, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  IconStar,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  PercentualLoyalty,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { ApplyLoyaltyOnStatusView } from '../shared/ApplyLoyaltyOnStatus/ApplyLoyaltyOnStatusView'
import { messages } from './messages'

type Props = ViewProps & {
  config: PercentualLoyalty
}

export function PercentualLoyaltyView(props: Props) {
  const { onEdit, onRemove, config } = props

  const { formatPercentual } = useNumbers()

  const { value, status } = config

  const handleEdit = () => onEdit(RegularBenefitVariant.PercentualLoyalty)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconStar />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Stack space="$space-2">
          <Tag>{formatPercentual(value)}</Tag>
          <ApplyLoyaltyOnStatusView status={status} />
        </Stack>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
